/**
 * Created by RamKumar on 6/10/16.
 */

;(function ( EG ) {
	"use strict";
	
	/**
	 * Sets a watch on UITK Autocomplete component
	 * This is used when the same component is used
	 * more than once on the same page
	 * Uses Observer Pattern
	 * Triggers appropriate callback on 'selection' & 'remove'
	 */
	function AutoCompleteWatches() {
		
		this.watchers = [];
		
		(function ( _this ) {
			uitk.subscribe('autocomplete.selected', function ( event, result ) {
				
				var id            = null,
						$autocomplete = result.$autocomplete;
				
				id = result.$autocomplete[ 0 ].id;
				
				if ( !id ) {
					return;
				}
				
				_.each(_this.watchers, function ( watcher ) {
					if ( id === watcher.$elem[ 0 ].id ) {
						watcher.onComplete(result);
					}
				})
				
			});
			
			uitk.subscribe('autocomplete.tag.remove', function ( event, result ) {
				var id = result.$autocomplete[ 0 ].id;

				if ( !id ) {
					return;
				}
				
				_.each(_this.watchers, function ( watcher ) {
					if ( id === watcher.$elem[ 0 ].id ) {
						watcher.onClear(result);
					}
				})
				
			});
			
		})(this);
		
	}
	
	/**
	 * Removes the watch from subscription
	 * @return {Boolean}
	 */
	function unwatch() {
		this.watches = _.reject(this.watches, function ( watch ) {
			if ( watch.callback == callback ) {
				return true;
			}
			return false;
		});
	}
	
	/**
	 * Sets a watch and trigger 'onComplete' & 'onClear' callbacks
	 * @param  {HTMLElement} $elem '$autoCompleteElement'
	 * @param  {Object} callbacks
	 *         {
   *           onComplete: function () {},
   *           onClear: function () {}
   *         }
	 * @return {undefined}
	 */
	AutoCompleteWatches.prototype.watch = function ( $elem, callbacks ) {
		
		if ( !$elem || !$elem.length ) {
			return;
		}
		var existingWatcher = _.find(this.watchers, function (watcher) {
			if (watcher.$elem[0]['id'] == $elem[0]['id']) {
                return true;
            }
            return false;
		});

        if (!existingWatcher) {
            this.watchers.push({
                $elem: $elem,
                onComplete: callbacks.onComplete,
                onClear: callbacks.onClear
            })
        }
	};
	
	EG.Users.Utils.AutoComplete = new AutoCompleteWatches();
	
})(EG);
